export default __webpack_public_path__ + "static/media/hessahStore9.932c80c7.jpg";